import { AxiosError } from "axios";
export var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["IOS"] = 0] = "IOS";
    DeviceType[DeviceType["ANDROID"] = 1] = "ANDROID";
    DeviceType[DeviceType["WEB"] = 2] = "WEB";
})(DeviceType || (DeviceType = {}));
export function getMappedLinkedAccounts(accounts) {
    let linkedAcc = [];
    if (accounts.length > 0) {
        accounts.forEach((acc) => {
            const linkedAccObj = {
                id: acc.id,
                fipId: acc.fip_Id,
                linkRefNumber: acc.confirm_link_ref_number,
                maskedAccNumber: acc.masked_account_number,
                accRefNumber: acc.ref_number,
                FIType: acc.type.id,
                accType: acc.type.account_sub_type.id,
            };
            linkedAcc.push(linkedAccObj);
        });
    }
    return linkedAcc;
}
export function getDeviceType() {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
        return DeviceType[DeviceType.ANDROID];
    }
    else if (/iPad|iPhone|iPod/.test(ua)) {
        return DeviceType[DeviceType.IOS];
    }
    return DeviceType[DeviceType.WEB];
}
export function getMappedLinkingRes(data) {
    let accLinkingDetails = [];
    if (data.accounts.length > 0) {
        data.accounts.forEach((acc) => {
            const accDetails = {
                customerAddress: acc.customer_Id,
                linkRefNumber: acc.confirm_link_ref_num,
                accRefNumber: acc.ref_number,
                maskedAccNumber: acc.masked_account_number,
                status: acc.status,
            };
            accLinkingDetails.push(accDetails);
        });
    }
    return {
        AccLinkDetails: accLinkingDetails
    };
}
export function checkForAltMobileNumber(mobileNum, crypto, availableStorage) {
    // const loggedInUser = crypto.decrypt(sessionStorage.getItem("userId"))
    const loggedInUser = availableStorage.getValue("userId");
    if (loggedInUser && loggedInUser.length === 10 && mobileNum.length === 10) {
        const isLoggedInUser = loggedInUser === mobileNum;
        return isLoggedInUser;
    }
    else if (loggedInUser &&
        loggedInUser.length !== 10 &&
        mobileNum.length === 10) {
        const loggedInMobile = loggedInUser.split("@")[0];
        const isLoggedInUser = loggedInMobile === mobileNum;
        return isLoggedInUser;
    }
    else {
        return false;
    }
}
export function getMappedDiscoveredAccounts(accounts) {
    let discoveredAccounts = [];
    if (accounts.length > 0) {
        accounts.forEach((acc) => {
            const discAccObject = {
                id: acc.id,
                accType: acc.account_sub_type_ID,
                accRefNumber: acc.ref_number,
                maskedAccNumber: acc.masked_account_number,
                FIType: acc.type_ID,
            };
            discoveredAccounts.push(discAccObject);
        });
    }
    return discoveredAccounts;
}
export function getConsentRequestDetailsMapped(data) {
    return {
        status: data.status,
        ver: data.ver,
        txnid: data.txnid,
        consentStatus: null,
        createTime: null,
        startTime: data.ConsentDetail.consentStart,
        expireTime: data.ConsentDetail.consentExpiry,
        statusLastupdateTimestamp: null,
        FIP: null,
        AA: {
            id: data.ConsentDetail.consentUseLogUri,
        },
        FIU: data.ConsentDetail.DataConsumer,
        User: data.ConsentDetail.Customer,
        Accounts: data.ConsentDetail.Accounts,
        ConsentUse: null,
        DataAccess: null,
        Purpose: data.ConsentDetail.Purpose,
        Signature: null,
        mode: data.ConsentDetail.consentMode,
        fetchType: data.ConsentDetail.fetchType,
        consentTypes: data.ConsentDetail.consentTypes,
        consentDisplayDescriptions: data.ConsentDetail.consentTypes,
        fiTypes: data.ConsentDetail.fiTypes,
        DataDateTimeRange: data.ConsentDetail.FIDataRange,
        DataLife: data.ConsentDetail.DataLife,
        Frequency: data.ConsentDetail.Frequency,
        DataFilter: [],
        consentDetailDigitalSignature: null,
        ConsentHandle: data.Consent_handle,
    };
}
export function getAccTypes(categories) {
    //id : FINANCIAL , group_id: All_Bank_Deposits
    if (categories.length > 0) {
        const filteredCategory = categories.filter((data) => data.id === "FINANCIAL");
        if (filteredCategory.length > 0) {
            const filteredGrp = filteredCategory[0].groups.filter((data) => data.group_id === "All_Bank_Deposits");
            if (filteredGrp.length > 0) {
                return filteredGrp[0].account_types;
            }
        }
    }
    return [];
}
function filterFitypes(availableFitypes, requiredFitypes) {
    return availableFitypes.filter(account => requiredFitypes.includes(account.id));
}
export function getFITypes(fipId, listOfFips, fiTypes) {
    if (listOfFips.length > 0 && fipId) {
        // Find the first matching FIP based on fipId
        const availableFip = listOfFips.find((data) => data.id === fipId);
        if (availableFip) {
            // If fiTypes is not provided, return all account_types
            if (!fiTypes) {
                return availableFip.account_types;
            }
            // Filter account_types based on fiTypes
            const reqFiTypes = filterFitypes(availableFip.account_types, fiTypes);
            // If filtered fiTypes exist, return them; otherwise, return all account_types
            return reqFiTypes && reqFiTypes.length > 0 ? reqFiTypes : availableFip.account_types;
        }
    }
    // Return undefined if conditions are not met
    return undefined;
}
export function handleErrors(error, aaOperation, attempt) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (error instanceof AxiosError && !error.response) {
        switch (error.code) {
            case AxiosError.ECONNABORTED:
                return {
                    message: "Connection to server lost. Please try again after sometime",
                    status: "AA_ERROR",
                    statusCode: "CONNECTION_LOST",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_BAD_OPTION:
            case AxiosError.ERR_BAD_OPTION_VALUE:
                return {
                    message: "Request option is invalid",
                    status: "AA_ERROR",
                    statusCode: "INVALID_REQUEST_OPTION",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_BAD_REQUEST:
            case AxiosError.ERR_BAD_RESPONSE:
                return {
                    message: "Invalid Data in request or response.",
                    status: "AA_ERROR",
                    statusCode: "INVALID_REQUEST_RESPONSE",
                    aaOperation
                };
            case AxiosError.ERR_CANCELED:
                return {
                    message: "Request got cancelled as it took too much of time.",
                    status: "AA_ERROR",
                    statusCode: "REQUEST_CANCELLED",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_DEPRECATED:
                return {
                    message: "Deprecated method used",
                    status: "AA_ERROR",
                    statusCode: "DEPRECATED",
                    aaOperation
                };
            case AxiosError.ERR_FR_TOO_MANY_REDIRECTS:
                return {
                    message: "Redirection to your site happened many times.",
                    status: "AA_ERROR",
                    statusCode: "TOO_MANY_REDIRECTS",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_INVALID_URL:
                return {
                    message: "Invalid URL",
                    status: "AA_ERROR",
                    statusCode: "INVALID_URL",
                    aaOperation
                };
            case AxiosError.ERR_NETWORK:
                return {
                    message: "Some issue with your network. Retry again or change your network.",
                    status: "AA_ERROR",
                    statusCode: "NETWORK_ISSUE",
                    aaOperation,
                    attempt
                };
            case AxiosError.ERR_NOT_SUPPORT:
                return {
                    message: "The https request is not suported.",
                    status: "AA_ERROR",
                    statusCode: "NOT_SUPPORTED",
                    aaOperation
                };
            case AxiosError.ETIMEDOUT:
                return {
                    message: "The request got timed out as it took much more time than expected.Please try after sometime.",
                    status: "AA_ERROR",
                    statusCode: "TIMED_OUT",
                    aaOperation,
                    attempt
                };
        }
    }
    if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) !== 401) {
        return {
            message: ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.user_friendly_message) || (error === null || error === void 0 ? void 0 : error.message),
            status: ((_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.status) || (error === null || error === void 0 ? void 0 : error.status) || "FAILURE",
            errorCode: ((_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.code) || ((_g = error === null || error === void 0 ? void 0 : error.context) === null || _g === void 0 ? void 0 : _g.aaErrorCode) || '',
            statusCode: ((_h = error === null || error === void 0 ? void 0 : error.response) === null || _h === void 0 ? void 0 : _h.status) || ((_k = (_j = error === null || error === void 0 ? void 0 : error.context) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.statusCode),
            aaOperation,
            attempt
        };
    }
    else {
        return {
            message: (error === null || error === void 0 ? void 0 : error.message) || "Some Error Occured. Please try again after some time.",
            status: "FAILURE",
            errorCode: ((_m = (_l = error === null || error === void 0 ? void 0 : error.response) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.code) || ((_o = error === null || error === void 0 ? void 0 : error.context) === null || _o === void 0 ? void 0 : _o.aaErrorCode) || '',
            statusCode: ((_p = error === null || error === void 0 ? void 0 : error.response) === null || _p === void 0 ? void 0 : _p.status) || ((_r = (_q = error === null || error === void 0 ? void 0 : error.context) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.statusCode),
            aaOperation,
            attempt
        };
    }
}
//# sourceMappingURL=index.js.map